import { useNavigate } from 'react-router-dom'
import { AGREEMENT_SECTIONS } from '../../shared/content/agreement'
import { useSession } from '../lib/session'

export function Agreement() {
  const navigate = useNavigate()
  const { household } = useSession()

  return (
    <div className="page">
      <div className="row-between">
        <h1 className="title">Our family agreement</h1>
        <button type="button" className="btn btn-quiet" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      <p className="subtitle">
        The rules {household?.name ?? 'we'} agreed together. The app just keeps track of them.
      </p>

      {AGREEMENT_SECTIONS.map((section) => (
        <section key={section.id} className="card">
          <h2 className="title">{section.title}</h2>
          {section.intro ? <p className="subtitle">{section.intro}</p> : null}
          <ul className="stack" style={{ margin: 0, paddingLeft: '1.1rem' }}>
            {section.items.map((item) => (
              <li key={item} style={{ lineHeight: 1.5 }}>
                {item}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
